import { render, staticRenderFns } from "./PerformanceBarChart.vue?vue&type=template&id=063cb4c0"
import script from "./PerformanceBarChart.vue?vue&type=script&lang=js"
export * from "./PerformanceBarChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports